import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import MUICheckbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import styled from "styled-components";

const CustomFormControlLabel = styled(FormControlLabel)`
    .MuiTypography-body1-53 {
        font-weight: 300;
    }
`;

const CustomCheckbox = withStyles({
    root: {
        color: "#A8BEFF",
        transform: "scale(1.5)",
        "&$checked": {
            color: "#2D5DEC",
        },
    },
    checked: {},
})((props) => <MUICheckbox color="default" {...props} />);

const Checkbox = (props) => {
    const { onChange, name, label, checked } = props;

    return (
        <CustomFormControlLabel
            label={label}
            control={
                <CustomCheckbox
                    onChange={onChange}
                    name={name}
                    checked={checked}
                />
            }
        ></CustomFormControlLabel>
    );
};

Checkbox.propTypes = {
    name: PropTypes.string,
    label: PropTypes.node,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
};

export default Checkbox;
